import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  console.log("[LANGUAGE ACTIVE]", currentLang);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("tef_ui_language", lng);
  };

  const isPT = currentLang === "pt-BR" || currentLang.startsWith("pt");
  const isEN = currentLang === "en" || currentLang.startsWith("en");
  const isFR = currentLang === "fr" || currentLang.startsWith("fr");

  return (
    <div className="flex items-center gap-2.5 px-3 py-2 bg-gray-50/80 backdrop-blur-xs rounded-xl border border-gray-100 w-full shadow-2xs">
      <Globe className="w-4 h-4 text-gray-400 shrink-0 animate-pulse" />
      <div className="flex flex-1 p-0.5 bg-gray-200/50 rounded-lg gap-1 border border-gray-200/20">
        <button
          type="button"
          onClick={() => changeLanguage("pt-BR")}
          className={`flex-1 py-1 text-xs font-bold rounded-md transition-all duration-200 cursor-pointer ${
            isPT
              ? "bg-white text-red-600 shadow-xs border border-gray-100"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          PT
        </button>
        <button
          type="button"
          onClick={() => changeLanguage("en")}
          className={`flex-1 py-1 text-xs font-bold rounded-md transition-all duration-200 cursor-pointer ${
            isEN
              ? "bg-white text-red-600 shadow-xs border border-gray-100"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          EN
        </button>
        <button
          type="button"
          onClick={() => changeLanguage("fr")}
          className={`flex-1 py-1 text-xs font-bold rounded-md transition-all duration-200 cursor-pointer ${
            isFR
              ? "bg-white text-red-600 shadow-xs border border-gray-100"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          FR
        </button>
      </div>
    </div>
  );
}
